import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedComponentsModule } from './components/shared-components.module';
import { SharedDirectivesModule } from './directives/shared-directives.module';
import { SharedModulesModule } from './modules/shared-modules.module';
import { SharedPipesModule } from './pipes/shared.pipes.module';
import { DialogInputModule } from './services/dialog-input/dialog-input.module';

@NgModule({
    declarations: [

    ],
    imports: [
        CommonModule,
        DialogInputModule,
        SharedComponentsModule,
        SharedDirectivesModule,
        SharedPipesModule,
        SharedModulesModule,
    ],
    providers: [],
    exports: [
        DialogInputModule,
        SharedComponentsModule,
        SharedDirectivesModule,
        SharedPipesModule,
        SharedModulesModule,
    ]
})

export class SharedModule {}
